import { authorizationStore } from '../store/authorizationStore';
import commons from './commons';
import { Information } from './flags';

const querySelectionPrefix = [
  {
    id: 'documentId',
    displayName: "ID",
    system: true,
    fieldName: "documentId",
    type: 0
  },
  {
    id: 'state',
    displayName: "State",
    system: true,
    fieldName: "state",
    type: "state"
  },
  {
    id: 'collaboration',
    displayName: "Collaboration",
    system: true,
    fieldName: "collaboration",
    type: "collaboration"
  },
  {
    id: 'date',
    displayName: "Date",
    system: true,
    fieldName: "date",
    type: 5
  },
  {
    id: 'assignTo',
    displayName: "Assign To",
    system: true,
    fieldName: "assignTo",
    type: 20
  },
  {
    id: 'due',
    displayName: "Due",
    system: true,
    fieldName: "due",
    type: 5
  },
  {
    id: 'createdBy',
    displayName: 'Created By',
    system: true,
    fieldName: "createdBy",
    type: 20
  },
  {
    id: 'createdDate',
    displayName: "Created Date",
    system: true,
    fieldName: "createdDate",
    type: 5
  },
  {
    id: 'lastChangeBy',
    displayName: "Last Change By",
    system: true,
    fieldName: "lastChangeBy",
    type: 20
  },
  {
    id: 'lastChangeDate',
    displayName: "Last Change Date",
    system: true,
    fieldName: "lastChangeDate",
    type: 5
  },
  {
    id: "username",
    displayName: "Username",
    system: true,
    fieldName: "username",
    type: 19,
  }
];

const querySelectionSuffix = [
  {
    displayName: "OR",
    fieldName: "or",
    type: "condition"
  },
  {
    displayName: "AND",
    fieldName: "and",
    type: "condition"
  },
  {
    displayName: "NOT",
    fieldName: "not",
    type: "condition",
    isBeta: true,
  },
  {
    displayName: "Formula",
    fieldName: "formula",
    type: "formula",
    isBeta: true,
  },
  {
    displayName: "Script",
    fieldName: "script",
    type: "custom",
    isBeta: true,
  }
];
/* never read */
const querySelectionSpecial = [
  {
    displayName: "OR",
    fieldName: "or",
    type: "condition"
  },
  {
    displayName: "AND",
    fieldName: "and",
    type: "condition"
  },
  {
    displayName: "NOT",
    fieldName: "not",
    type: "condition"
  },
  {
    displayName: "Script",
    fieldName: "script",
    type: "custom"
  }
];

const getInformationType = (informationSource, fieldId) => {
  let filterType = null;
  const findInformation = informationSource.find(x => x.id === fieldId);
  if (findInformation && (findInformation.type !== undefined || findInformation.type !== null))
    filterType = findInformation.type;

  if (Number.isInteger(filterType))
    return commons.informationTypes.find(x => x.id == filterType).type;

  return filterType;
}

const getSearchTypes = function (filterType) {
  switch (filterType) {
    case Information.Text.Type:
    case Information.MultilineText.Type:
    case Information.Select.Type:
    case Information.Tag.Type:
    case Information.Module.Type:
    case Information.Modules.Type:
    case Information.Email.Type:
    case Information.Phone.Type:
    case Information.URL.Type:
    case "Text":
    case "Multiline Text":
    case "Select":
    case "Tag":
    case "Locus":
    case "Module":
    case "Modules":
    case "Email":
    case "Phone Number":
    case "Link":
    case "URL":
      return [
        { displayName: "contains", fieldName: "contains" },
        { displayName: "does not contain", fieldName: "notContains" },
        { displayName: "is", fieldName: "is" },
        { displayName: "is not", fieldName: "isNot" },
        { displayName: "starts with", fieldName: "startsWith" },
        { displayName: "does not start with", fieldName: "notStartsWith" },
        { displayName: "ends with", fieldName: "endsWith" },
        { displayName: "does not end with", fieldName: "notEndsWith" },
        { displayName: "blank", fieldName: "isNone" },
        { displayName: "not blank", fieldName: "isNotNone" }
      ];
    case Information.Location.Type:
    case "Location":
      return [
        { displayName: "contains", fieldName: "contains" },
        { displayName: "does not contain", fieldName: "notContains" },
        { displayName: "is", fieldName: "is" },
        { displayName: "is not", fieldName: "isNot" },
        { displayName: "starts with", fieldName: "startsWith" },
        { displayName: "does not start with", fieldName: "notStartsWith" },
        { displayName: "ends with", fieldName: "endsWith" },
        { displayName: "does not end with", fieldName: "notEndsWith" },
        { displayName: "blank", fieldName: "isNone" },
        { displayName: "not blank", fieldName: "isNotNone" }
      ];

    case Information.Integer.Type:
    case Information.Number.Type:
    case Information.Money.Type:
    case "Integer":
    case "Number":
    case "Money":
      return [
        { displayName: "between", fieldName: "between" },
        { displayName: "greater than or equal", fieldName: "gte" },
        { displayName: "greater than", fieldName: "gt" },
        { displayName: "less than or equal", fieldName: "lte" },
        { displayName: "less than", fieldName: "lt" },
        { displayName: "equal", fieldName: "eq" },
        { displayName: "not equal", fieldName: "ne" },
        { displayName: "blank", fieldName: "isNone" },
        { displayName: "not blank", fieldName: "isNotNone" }
      ];
    case Information.YesNo.Type:
    case "YesNo":
    case "Yes No":
      return [
        { displayName: "yes", fieldName: "yes" },
        { displayName: "no", fieldName: "no" },
        { displayName: "blank", fieldName: "none" }
      ];
    case Information.Date.Type:
    case Information.DateTime.Type:
    case "Date":
    case "Date Time":
      return [
        { displayName: "is", fieldName: "is" },
        { displayName: "between", fieldName: "between" },
        { displayName: "within", fieldName: "within" },
        { displayName: "on or after", fieldName: "gte" },
        { displayName: "after", fieldName: "gt" },
        { displayName: "on or before", fieldName: "lte" },
        { displayName: "before", fieldName: "lt" },
        { displayName: "in", fieldName: "in" },
        { displayName: "past", fieldName: "past" },
        { displayName: "blank", fieldName: "none" },
        { displayName: "not blank", fieldName: "isNotNone" }
      ];
    case Information.User.Type:
    case Information.Users.Type:
    case Information.Username.Type:
    case "User":
    case "Users":
    case "Profile (Module)":
    case "Username":
      return [
        { displayName: "is me", fieldName: "me" },
        { displayName: "is", fieldName: "is" },
        { displayName: "contains", fieldName: "contains" },
        { displayName: "blank", fieldName: "none" },
        { displayName: "not blank", fieldName: "isNotNone" }
      ];
    case "Table":
      return [
        { displayName: "with", fieldName: "any" },
        { displayName: "without", fieldName: "notIn" },
        { displayName: "blank", fieldName: "isNone" },
        { displayName: "not blank", fieldName: "isNotNone" }
      ];
    case "collaboration":
      return [
        { displayName: "comment last", fieldName: "lastComment" },
        { displayName: "comment", fieldName: "comment" },
        { displayName: "blank", fieldName: "none" }
      ];
    case "state":
      return [
        { displayName: "is", fieldName: "is" },
        { displayName: "not", fieldName: "isNot" }
      ];
    case Information.Formula.Type:
    case "formula":
      return [
        { displayName: "is", fieldName: "is" },
        { displayName: "not", fieldName: "isNot" },
        { displayName: "greater than", fieldName: "gt" },
        { displayName: "less than", fieldName: "lt" },
        { displayName: "greater than or equal", fieldName: "gte" },
        { displayName: "less than or equal", fieldName: "lte" },
        { displayName: "equal", fieldName: "eq" },
      ];
  }
};

/* Studio schedules (docs/scheduling-routine-automation-proposal.md §5): the operators a schedule's
   condition offers. Dates are relative to the run day: `on` picks one day, and before/after take an
   offset from the run day instead of a fixed date. "is me" is gone because a schedule runs with
   nobody signed in. Every other type keeps the listing builder's operators. */
const SCHEDULE_MODE = "schedule";

const scheduleDateSearchTypes = Object.freeze([
  { displayName: "is on", fieldName: "on" },
  { displayName: "is on or before", fieldName: "lte" },
  { displayName: "is before", fieldName: "lt" },
  { displayName: "is on or after", fieldName: "gte" },
  { displayName: "is after", fieldName: "gt" },
  { displayName: "within", fieldName: "within" },
  { displayName: "in the next", fieldName: "in" },
  { displayName: "in the past", fieldName: "past" },
  { displayName: "blank", fieldName: "none" },
  { displayName: "not blank", fieldName: "isNotNone" }
]);

/* Date operators whose payload is { duration, offset } from the run day in schedule mode. */
const scheduleRelativeOperators = Object.freeze(["on", "gte", "gt", "lte", "lt"]);

const isDateFilterType = (filterType) => [
  Information.Date.Type, Information.DateTime.Type, "Date", "Date Time"
].includes(filterType);

const getScheduleSearchTypes = function (filterType) {
  if (isDateFilterType(filterType)) {
    return scheduleDateSearchTypes.map(x => ({ ...x }));
  }
  const searchTypes = getSearchTypes(filterType);
  return Array.isArray(searchTypes) ? searchTypes.filter(x => x.fieldName !== "me") : searchTypes;
};

/* Mode-aware operator list: the schedule set in schedule mode, the listing set otherwise. */
const getSearchTypesForMode = function (filterType, mode) {
  return mode === SCHEDULE_MODE ? getScheduleSearchTypes(filterType) : getSearchTypes(filterType);
};

/* The fields and groups a schedule's condition may use. Script and formula clauses can reach the
   Python engine and the server refuses NOT groups on a schedule; collaboration is about who
   commented, which a schedule has no one to compare with. */
const isScheduleSelectable = (column) => {
  if (!column) return false;
  if (column.type === "custom" || column.type === "formula" || column.type === "collaboration") return false;
  if (column.type === "condition" && column.fieldName === "not") return false;
  return true;
};

const getDatePredefinedselection = function (durationType) {
  switch (durationType) {
    case 'day':
      return [
        { displayName: "today (" + moment().format("dddd") + ")", offset: 0 },
        {
          displayName:
            "yesterday (" +
            moment()
              .subtract(1, "days")
              .format("dddd") +
            ")",
          offset: -1
        },
        {
          displayName:
            "previous day (" +
            moment()
              .subtract(2, "days")
              .format("dddd") +
            ")",
          offset: -2
        },
        {
          displayName:
            "tomorrow (" +
            moment()
              .add(1, "days")
              .format("dddd") +
            ")",
          offset: 1
        },
        {
          displayName:
            "next day (" +
            moment()
              .add(2, "days")
              .format("dddd") +
            ")",
          offset: 2
        }
      ];

    case 'week':
      return [
        {
          displayName: "this week (" + moment().format("ww") + ")",
          offset: 0
        },
        {
          displayName:
            "last week (" +
            moment()
              .subtract(1, "weeks")
              .format("ww") +
            ")",
          offset: -1
        },
        {
          displayName:
            "previous week (" +
            moment()
              .subtract(2, "weeks")
              .format("ww") +
            ")",
          offset: -2
        },
        {
          displayName:
            "next week (" +
            moment()
              .add(1, "weeks")
              .format("ww") +
            ")",
          offset: 1
        }
      ];

    case 'month':
      return [
        {
          displayName: "this month (" + moment().format("MMMM") + ")",
          offset: 0
        },
        {
          displayName:
            "last month (" +
            moment()
              .subtract(1, "months")
              .format("MMMM") +
            ")",
          offset: -1
        },
        {
          displayName:
            "previous month (" +
            moment()
              .subtract(2, "months")
              .format("MMMM") +
            ")",
          offset: -2
        },
        {
          displayName:
            "next month (" +
            moment()
              .add(1, "months")
              .format("MMMM") +
            ")",
          offset: 1
        }
      ];

    case 'year':
      return [
        {
          displayName: "this year (" + moment().format("YYYY") + ")",
          offset: 0
        },
        {
          displayName:
            "last year (" +
            moment()
              .subtract(1, "years")
              .format("YYYY") +
            ")",
          offset: -1
        },
        {
          displayName:
            "next year (" +
            moment()
              .add(1, "years")
              .format("YYYY") +
            ")",
          offset: 1
        }
      ];
  }
}

const prepareQueryUnit = function (informationSource, id, payload = {}, mode) {
  try {
    const information = informationSource.find(x => x.id === id);
    if (information) {
      let filterType = information.type;
      if (Number.isInteger(filterType)) {
        filterType = commons.informationTypes.find(x => x.id == filterType).type;
      }

      let result = {
        fieldId: information.id,
        fieldName: information.fieldName,
        operator: getSearchTypesForMode(filterType, mode)[0].fieldName,
        system: information.system
      }

      /* schedule mode: a date condition starts as "is on the run day" */
      if (mode === SCHEDULE_MODE && scheduleRelativeOperators.includes(result.operator)) {
        result.payload = { duration: "day", offset: 0 };
      }

      if (
        (information.type == 19 || information.type == 20) &&
        payload && payload.isFirst
      ) {
        result.operator = 'is';
      }

      if (
        information.type == 27 &&
        Array.isArray(information.optionList) &&
        information.optionList.length
      ) {
        result.operator = 'is';
      }

      return result;
    } else {
      throw 'information not found.';
    }
  } catch (err) {
    console.error(err);
    return null;
  }
}
/**
 * 
 * @param {Object} column 
 * @returns 
 */
const getColumnSearchableRelease = (column) => {
  if (column.isBeta) {
    return "beta";
  }

  const findInformationType = commons.informationTypes.find(x => x.id == column.type);
  if (findInformationType) {
    if (findInformationType.searchableRelease == "dev") {
      return "dev";
    } else if (findInformationType.searchableRelease == "alpha") {
      return "alpha";
    } else if (findInformationType.searchableRelease == "beta") {
      return "beta";
    }
  }
  return null;
}
/**
 * 
 * @param {Object} column 
 * @param {Object} param
 * @param {boolean} param.workspaceBeta 
 * @returns 
 */
const isSearchableColumn = (column, { workspaceBeta } = {}) => {
  if (column.isBeta) {
    return authorizationStore.getters.isBeta || workspaceBeta;
  }

  if (column.type == "condition") {
    return querySelectionSuffix.some(x => x.fieldName == column.fieldName);
  }

  if (column.system) {
    return querySelectionPrefix.some(x => x.id == column.id);
  }

  const findInformationType = commons.informationTypes.find(x => x.id == column.type);
  if (findInformationType) {
    if (findInformationType.searchableRelease) {
      switch (findInformationType.searchableRelease) {
        case "dev":
          return authorizationStore.getters.isDevelopment;
        case "alpha":
          return authorizationStore.getters.isInternal;
        case "beta":
          return authorizationStore.getters.isBeta || workspaceBeta;
      }
    }
    return findInformationType.searchable;
  }
  return false;
}
/**
 * 
 * @param {Array} columns 
 * @param {Object} param
 * @param {boolean} param.workspaceBeta 
 * @returns 
 */
const getSearchableColumns = (columns, { workspaceBeta } = {}) => {
  if (Array.isArray(columns)) {
    return columns.filter(column => isSearchableColumn(column, { workspaceBeta: workspaceBeta }));
  }
  return [];
}
/**
 * 
 * @param {Array} columns 
 * @param {Object} param
 * @param {boolean} param.workspaceBeta 
 * @returns 
 */
const getDefaultQueryFilter = (columns, { workspaceBeta } = {}) => {
  try {
    const searchableColumns = getSearchableColumns(columns, { workspaceBeta: workspaceBeta });
    if (Array.isArray(searchableColumns) && searchableColumns.length) {
      return {
        id: commons.nanoID(),
        ...prepareQueryUnit(
          searchableColumns,
          searchableColumns[0].id,
          { isFirst: true }
        )
      }
    }
  } catch (err) {
    console.warn(err);
  }
}
/**
 * 
 * @param {Array} filtersItems 
 * @param {Object} filtersItem 
 */
const removeFiltersItem = (filtersItems, filtersItem) => {
  filtersItems.splice(filtersItems.indexOf(filtersItem), 1);
}
/**
 * 
 * @param {Array} columns 
 * @param {Array} filtersItems 
 */
const queryFiltersRecursive = (columns, filtersItems) => {
  const filters = [...filtersItems];
  filters.forEach(x => {
    if (x.items && Array.isArray(x.items)) {
      const information = columns.find(y => y.id === x.fieldId);
      if (information && information.type == 14) {
        if (information.fields) {
          queryFiltersRecursive(information.fields, x.items);
        } else {
          queryFiltersRecursive([], x.items);
        }
      } else {
        queryFiltersRecursive(columns, x.items);
      }
      if (!(x.items && x.items.length)) {
        removeFiltersItem(filtersItems, x);
      }
    } else {
      const item = columns.find(y => y.id === x.fieldId);
      if (!item) {
        removeFiltersItem(filtersItems, x);
      }
    }
  });
}
/**
 * 
 * @param {Array} columns 
 * @param {Array} filters 
 */
const updateQueryFilters = (columns, filters) => {
  if (filters && filters.items && Array.isArray(filters.items)) {
    queryFiltersRecursive(columns, filters.items);
    // if (!(filters.items && filters.items.length)) {
    //   const filtersItem = getDefaultQueryFilter(columns);
    //   if (filtersItem) {
    //     filters.items.push(filtersItem);
    //   }
    // }
  }
}

/* `typeof null === "object"`, so a filter unit persisted with `payload: null` (an empty Date
   filter has been stored that way since 05e56e34) used to take the object branches below and
   dereference payload.max / .min / .id / .duration, throwing out of getFiltersValidity and
   aborting listing initialisation - SS06087 / SS06088 / SS06089. A null payload holds no value,
   so it has to read as an unfilled unit. Arrays keep taking the object branch as before. */
const isPayloadObject = (payload) => payload !== null && typeof payload === "object";

const isValueDefined = (value) => {
  return value !== null && value !== undefined && value !== "";
}
/**
 * 
 * @param {Object} filters 
 * @returns {boolean}
 */
const getFiltersValidity = (filters) => {
  if (!Array.isArray(filters.items)) {
    return false;
  }

  return filters.items.some(item => {
    if (item.items) {
      return getFiltersValidity(item);
    }

    if (item.fieldId === "collaboration" && ["lastIntentionComment", "lastIntention", "lastComment", "intention", "comment"].includes(item.operator)) {
      return true;
    }

    if (item.fieldId === "state") {
      if (isPayloadObject(item.payload)) {
        return isValueDefined(item.payload.id);
      }
      return false;
    }

    if (["isNone", "none", "isNotNone", "me", "yes", "no"].includes(item.operator)) {
      return true;
    }

    if (["contains", "notContains", "is", "isNot", "startsWith", "notStartsWith", "endsWith", "notEndsWith", "eq", "ne", "gt", "lt"].includes(item.operator)) {
      return isValueDefined(item.payload);
    }

    if (item.operator === "between") {
      if (isPayloadObject(item.payload)) {
        return (
          (isValueDefined(item.payload.min) && isValueDefined(item.payload.max)) ||
          (isValueDefined(item.payload.startDate) && isValueDefined(item.payload.endDate))
        );
      }
      return false;
    }

    if (item.operator === "gte") {
      if (isPayloadObject(item.payload)) {
        return isValueDefined(item.payload.min);
      }
      return isValueDefined(item.payload);
    }

    if (item.operator === "lte") {
      if (isPayloadObject(item.payload)) {
        return isValueDefined(item.payload.max);
      }
      return isValueDefined(item.payload);
    }

    if (["within", "in", "past"].includes(item.operator)) {
      if (isPayloadObject(item.payload)) {
        return isValueDefined(item.payload.duration) && isValueDefined(item.payload.offset);
      }
      return false;
    }

    return false;
  });
}
/**
 * 
 * @param {Object} obj 
 * @param {Set<string>} seen 
 * @param {Array} result 
 * @returns {Array}
 */
const flattenFilters = (obj, seen = new Set(), result = []) => {
  if (!obj.items || !Array.isArray(obj.items)) return result;

  for (const item of obj.items) {
    if (Array.isArray(item.items)) {
      flattenFilters(item, seen, result);
    } else if (!seen.has(item.fieldId)) {
      seen.add(item.fieldId);
      result.push(item);
    }
  }

  return result;
};
/**
 * 
 * @param {Array} filters 
 * @param {Array} sources 
 * @returns {Array}
 */
const getNonExistingFilters = (filters, sources) => {
  const sourceIds = new Set(sources.map(x => x.id));

  return filters
    .filter(x =>
      x.hasOwnProperty('fieldId') &&
      x.hasOwnProperty('fieldName') &&
      !sourceIds.has(x.fieldId)
    )
    .map(x => {
      let obj = {
        id: x.fieldId,
        displayName: x.displayName,
        fieldName: x.fieldName,
        type: x.type
      }

      if (x.system) {
        const queryPrefix = querySelectionPrefix.find(y => y.id == x.fieldId);

        if (queryPrefix) {
          return queryPrefix;
        }

        obj.system = true;
      }

      return obj;
    });
}

export default {
  querySelectionPrefix: querySelectionPrefix,
  querySelectionSuffix: querySelectionSuffix,
  getInformationType: getInformationType,
  getSearchTypes: getSearchTypes,
  SCHEDULE_MODE: SCHEDULE_MODE,
  scheduleRelativeOperators: scheduleRelativeOperators,
  getScheduleSearchTypes: getScheduleSearchTypes,
  getSearchTypesForMode: getSearchTypesForMode,
  isScheduleSelectable: isScheduleSelectable,
  getDatePredefinedselection: getDatePredefinedselection,
  prepareQueryUnit: prepareQueryUnit,
  getColumnSearchableRelease: getColumnSearchableRelease,
  getSearchableColumns: getSearchableColumns,
  getDefaultQueryFilter: getDefaultQueryFilter,
  updateQueryFilters: updateQueryFilters,
  getFiltersValidity: getFiltersValidity,
  flattenFilters: flattenFilters,
  getNonExistingFilters: getNonExistingFilters
}